import { MeridianPropertyType } from "@/enums/meridian/meridianpPropertyType";
import { AccountType, AssetType, CitizenshipStatus, HousingStatus, IncomeSourceType, LiabilityType, MaritalStatus, OccupancyType, PropertyStatus } from "../borrower";
import { CollectionMethod } from "../loan-demographics";
import { GiftOrGrantSourceType, HousingExpenseTimingType, HousingExpenseType, PropertyType } from "../loan-property";
import { MismoApplicationTakenMethodType, MismoAssetType, MismoCitizenshipResidencyType, MismoGiftOrGrantSourceType, MismoHousingExpenseTimingType, MismoHousingExpenseType, MismoIncomeSourceType, MismoLiabilityType, MismoMaritalStatus, MismoOwnedPropertyDispositionStatusType, MismoPropertyUsageType, MismoResisdencyTypeBasis } from "../mismo-loan";
import { PortalPropertyType } from "@/enums/mortdash/portalPropertyType";
import { MeridianLoanPurposeType } from "@/enums/meridian/meridianLoanPurposeType";
import { PortalLoanPurposeType } from "@/enums/mortdash/portalLoanPurposeType";
import { MeridianOccupancyType } from "@/enums/meridian/meridianOccupancyType";
import { PortalOccupancyType, PortalOccupancyTypeCOC } from "@/enums/mortdash/portalOccupancyType";
import { MeridianLoanPurposeTextType } from "@/enums/meridian/meridianLoanPurposeTextType";
import { PortalKeyDatesType } from '@/enums/mortdash/portalKeyDatesType'
import { MeridianKeyDatesType } from '@/enums/meridian/meridianKeyDatesType'
import { MeridianStateType, AK_CountyType, AL_CountyType, AR_CountyType, AZ_CountyType, CA_CountyType, CO_CountyType, CT_CountyType, DE_CountyType, FL_CountyType, GA_CountyType, HI_CountyType, IA_CountyType, ID_CountyType, IL_CountyType, IN_CountyType, KS_CountyType, KY_CountyType, LA_CountyType, MA_CountyType, MD_CountyType, ME_CountyType, MI_CountyType, MN_CountyType, MO_CountyType, MS_CountyType, MT_CountyType, NC_CountyType, ND_CountyType, NE_CountyType, NH_CountyType, NJ_CountyType, NM_CountyType, NV_CountyType, NY_CountyType, OH_CountyType, OK_CountyType, OR_CountyType, PA_CountyType, RI_CountyType, SC_CountyType, SD_CountyType, TN_CountyType, TX_CountyType, UT_CountyType, VA_CountyType, VT_CountyType, WA_CountyType, WI_CountyType, WV_CountyType, WY_CountyType } from '@/enums/meridian/meridianCountyType'
import { PortalModeType } from "@/enums/portal/portalModeType";
import { MeridianPortalModeType } from "@/enums/meridian/meridianPortalModeType";
import { PortalCitizenshipType } from "@/enums/portal/portalCitizenshipType";
import { PortalStructureType } from "@/enums/portal/portalStructureType";
import { PricingImpoundType, PricingImpoundTypeText } from "@/enums/meridian/pricingImpoundType";
import { MismoIncomeSourceType2, MismoOwnedPropertyDispositionStatusType2 } from "../retail/mismo-loan.types";
import { LoanApplicationMaritalStatus } from "@/enums/loanApplication/maritalStatus.enum";
import { LoanEmploymentMonthlyIncomeType } from "@/enums/loanApplication/loanEmploymentMonthlyIncomeType.enum";
import { LoanOtherIncomeType } from "@/enums/loanApplication/loanEmploymentIncomeType.enum";

export const MismoAssetTypeToMortdash = (mismoAssetType: MismoAssetType) => {
	switch (mismoAssetType) {
		case MismoAssetType.RealEstateOwned:
			return AssetType.REAL_ESTATE
		case MismoAssetType.CheckingAccount:
			return AssetType.CHECKING
		default:
			break;
	}
}

export const MismoAssetTypeToMortdashAccountType = (mismoAssetType: MismoAssetType) => {
	switch (mismoAssetType) {
		case MismoAssetType.RealEstateOwned:
			return AccountType.REAL_ESTATE
		case MismoAssetType.CheckingAccount:
			return AccountType.CHECKING
		case MismoAssetType.GiftOfPropertyEquity:
			return AccountType.GIFT_OF_PROPERTY_EQUITY;
		case MismoAssetType.Bond:
			return AccountType.BOND;
		case MismoAssetType.BridgeLoanNotDeposited:
			return AccountType.BRIDGE_LOAN_NOT_DEPOSITED;
		case MismoAssetType.CertificateOfDepositTimeDeposit:
			return AccountType.CERTIFICATE_OF_DEPOSIT_TIME_DEPOSIT;
		case MismoAssetType.IndividualDevelopmentAccount:
			return AccountType.INDIVIDUAL_DEVELOPMENT_ACCOUNT;
		case MismoAssetType.LifeInsurance:
			return AccountType.LIFE_INSURANCE;
		case MismoAssetType.MoneyMarketFund:
			return AccountType.MONEY_MARKET_FUND;
		case MismoAssetType.MutualFund:
			return AccountType.MUTUAL_FUND;
		case MismoAssetType.RetirementFund:
			return AccountType.RETIREMENT_FUND;
		case MismoAssetType.SavingsAccount:
			return AccountType.SAVINGS_ACCOUNT;
		case MismoAssetType.Stock:
			return AccountType.STOCK;
		case MismoAssetType.StockOptions:
			return AccountType.STOCK_OPTIONS;
		case MismoAssetType.TrustAccount:
			return AccountType.TRUST_ACCOUNT;
		case MismoAssetType.Other:
			return AccountType.OTHER;
		case MismoAssetType.CHECKING:
			return AccountType.CHECKING;
		case MismoAssetType.SAVINGS:
			return AccountType.SAVINGS;
		case MismoAssetType.MONEY_MARKET:
			return AccountType.MONEY_MARKET;
		case MismoAssetType.CD:
			return AccountType.CD;
		case MismoAssetType.INVESTMENT:
			return AccountType.INVESTMENT;
		case MismoAssetType.RETIREMENT:
			return AccountType.RETIREMENT;
		case MismoAssetType.REAL_ESTATE:
			return AccountType.REAL_ESTATE;
		case MismoAssetType.GIFT_OF_CASH:
			return AccountType.GIFT_OF_CASH;
		case MismoAssetType.GRANT:
			return AccountType.GRANT;
		default:
			break;
	}
}

export const MismoResidencyTypeBasisToMortdashHousingStatus = (mismoResidencyType: MismoResisdencyTypeBasis) => {
	switch (mismoResidencyType) {
		case MismoResisdencyTypeBasis.Own:
			return HousingStatus.OWN
		case MismoResisdencyTypeBasis.Rent:
			return HousingStatus.RENT
		case MismoResisdencyTypeBasis.LivinRentFree:
			return HousingStatus.LIVING_RENT_FREE
		default:
			break;
	}
}

export const MismoOwnedPropertyDispositionStatusTypeToMortdashStatusType = (type: MismoOwnedPropertyDispositionStatusType) => {
	switch (type) {
		case MismoOwnedPropertyDispositionStatusType.Retained:
			return PropertyStatus.RETAINED
		case MismoOwnedPropertyDispositionStatusType.PendingSale:
			return PropertyStatus.PENDING
		case MismoOwnedPropertyDispositionStatusType.Sold:
			return PropertyStatus.SOLD
		default:
			break;
	}
}

export const MismoPropertyUsageTypeToMortdashOccupancyType = (type: MismoPropertyUsageType) => {
	switch (type) {
		case MismoPropertyUsageType.Investment:
			return OccupancyType.INVESTMENT
		case MismoPropertyUsageType.PrimaryResidence:
			return OccupancyType.PRIMARY_RESIDENCE
		case MismoPropertyUsageType.SecondHome:
			return OccupancyType.SECOND_HOME
		default:
			break;
	}
}

export const MismoApplicationTakenMethodTypeToMortdashCollectionMethod = (type: MismoApplicationTakenMethodType) => {
	switch (type) {
		case MismoApplicationTakenMethodType.FaceToFace:
			return CollectionMethod.FACE_TO_FACE
		case MismoApplicationTakenMethodType.Fax:
			return CollectionMethod.FAX	
		case MismoApplicationTakenMethodType.Internet:
			return CollectionMethod.EMAIL	
		case MismoApplicationTakenMethodType.Telephone:
			return CollectionMethod.TELEPHONE		
		default:
			break;
	}
}

export const MismoIncomeSourceTypeToMortdashIncomeSourceType = (type: MismoIncomeSourceType) => {
	switch (type) {
		case MismoIncomeSourceType.Alimony:
			return IncomeSourceType.ALIMONY
		case MismoIncomeSourceType.ChildSupport:
			return IncomeSourceType.CHILD_SUPPORT
		case MismoIncomeSourceType.DefinedContributionPlan:
			return IncomeSourceType.DEFINED_CONTRIBUTION_PLAN
		case MismoIncomeSourceType.Disability:
			return IncomeSourceType.DISABILITY
		case MismoIncomeSourceType.DividendsInterest:
			return IncomeSourceType.DIVIDENDS_INTEREST
		case MismoIncomeSourceType.FosterCare:
			return IncomeSourceType.FOSTER_CARE
		case MismoIncomeSourceType.HousingAllowance:
			return IncomeSourceType.HOUSING_ALLOWANCE
		case MismoIncomeSourceType.Other:
			return IncomeSourceType.OTHER
		case MismoIncomeSourceType.AutomobileAllowance:
			return IncomeSourceType.AUTOMOBILE_ALLOWANCE
		case MismoIncomeSourceType.BoarderIncome:
			return IncomeSourceType.BOARDER_INCOME
		case MismoIncomeSourceType.CapitalGains:
			return IncomeSourceType.CAPITAL_GAINS
		case MismoIncomeSourceType.MortgageCreditCertificate:
			return IncomeSourceType.MORTGAGE_CREDIT_CERTIFICATE
		case MismoIncomeSourceType.MortgageDifferential:
			return IncomeSourceType.MORTGAGE_DIFFERENTIAL
		case MismoIncomeSourceType.NotesReceivableInstallment:
			return IncomeSourceType.NOTES_RECEIVABLE_INSTALLMENT
		case MismoIncomeSourceType.Pension:
			return IncomeSourceType.PENSION
		case MismoIncomeSourceType.PublicAssistance:
			return IncomeSourceType.PUBLIC_ASSISTANCE
		case MismoIncomeSourceType.Royalties:
			return IncomeSourceType.ROYALTIES
		case MismoIncomeSourceType.SeparateMaintenance:
			return IncomeSourceType.SEPARATE_MAINTENANCE
		case MismoIncomeSourceType.SocialSecurity:
			return IncomeSourceType.SOCIAL_SECURITY
		case MismoIncomeSourceType.Trust:
			return IncomeSourceType.TRUST
		case MismoIncomeSourceType.Unemployment:
			return IncomeSourceType.UNEMPLOYMENT
		case MismoIncomeSourceType.VABenefitsNonEducational:
			return IncomeSourceType.VA_BENEFITS_NON_EDUCATIONAL
		case MismoIncomeSourceType.JobRelatedExpenses:
			return IncomeSourceType.JOB_RELATED
		case MismoIncomeSourceType.SeparateMaintenanceExpense:
			return IncomeSourceType.SEPARATE_MAINTENANCE_EXPENSE
		default:
			break;
	}
}

export const MortdashIncomeSourceTypeToMismoIncomeSourceType = (type: IncomeSourceType) => {
	switch (type) {
		case IncomeSourceType.ALIMONY:
			return MismoIncomeSourceType.Alimony
		case IncomeSourceType.CHILD_SUPPORT:
			return MismoIncomeSourceType.ChildSupport
		case IncomeSourceType.DEFINED_CONTRIBUTION_PLAN:
			return MismoIncomeSourceType.DefinedContributionPlan
		case IncomeSourceType.DISABILITY:
			return MismoIncomeSourceType.Disability
		case IncomeSourceType.DIVIDENDS_INTEREST:
			return MismoIncomeSourceType.DividendsInterest
		case IncomeSourceType.FOSTER_CARE:
			return MismoIncomeSourceType.FosterCare
		case IncomeSourceType.HOUSING_ALLOWANCE:
			return MismoIncomeSourceType.HousingAllowance
		case IncomeSourceType.AUTOMOBILE_ALLOWANCE:
			return MismoIncomeSourceType.AutomobileAllowance
		case IncomeSourceType.BOARDER_INCOME:
			return MismoIncomeSourceType.BoarderIncome
		case IncomeSourceType.CAPITAL_GAINS:
			return MismoIncomeSourceType.CapitalGains
		case IncomeSourceType.MORTGAGE_CREDIT_CERTIFICATE:
			return MismoIncomeSourceType.MortgageCreditCertificate
		case IncomeSourceType.MORTGAGE_DIFFERENTIAL:
			return MismoIncomeSourceType.MortgageDifferential
		case IncomeSourceType.NOTES_RECEIVABLE_INSTALLMENT:
			return MismoIncomeSourceType.NotesReceivableInstallment
		case IncomeSourceType.PENSION:
			return MismoIncomeSourceType.Pension
		case IncomeSourceType.PUBLIC_ASSISTANCE:
			return MismoIncomeSourceType.PublicAssistance
		case IncomeSourceType.ROYALTIES:
			return MismoIncomeSourceType.Royalties
		case IncomeSourceType.SEPARATE_MAINTENANCE:
			return MismoIncomeSourceType.SeparateMaintenance
		case IncomeSourceType.SOCIAL_SECURITY:
			return MismoIncomeSourceType.SocialSecurity
		case IncomeSourceType.TRUST:
			return MismoIncomeSourceType.Trust
		case IncomeSourceType.UNEMPLOYMENT:
			return MismoIncomeSourceType.Unemployment
		case IncomeSourceType.VA_BENEFITS_NON_EDUCATIONAL:
			return MismoIncomeSourceType.VABenefitsNonEducational
		case IncomeSourceType.JOB_RELATED:
			return MismoIncomeSourceType.JobRelatedExpenses
		case IncomeSourceType.SEPARATE_MAINTENANCE_EXPENSE:
			return MismoIncomeSourceType.SeparateMaintenanceExpense
		case IncomeSourceType.OTHER:
			return MismoIncomeSourceType.Other
		default:
			break;
	}
}

export const MortdashToMismoAssetType = (assetType: AssetType) => {
	switch (assetType) {
		case AssetType.REAL_ESTATE:
			return MismoAssetType.RealEstateOwned
		case AssetType.CHECKING:
			return MismoAssetType.CheckingAccount
		default:
			break;
	}
}

export const MortdashAccountTypeToMismoAssetType = (accountType: AccountType) => {
	switch (accountType) {
		case AccountType.REAL_ESTATE:
			return MismoAssetType.RealEstateOwned
		case AccountType.CHECKING:
			return MismoAssetType.CheckingAccount
		case AccountType.GIFT_OF_PROPERTY_EQUITY:
			return MismoAssetType.GiftOfPropertyEquity
		case AccountType.BOND:
			return MismoAssetType.Bond
		case AccountType.BRIDGE_LOAN_NOT_DEPOSITED:
			return MismoAssetType.BridgeLoanNotDeposited
		case AccountType.CERTIFICATE_OF_DEPOSIT_TIME_DEPOSIT:
			return MismoAssetType.CertificateOfDepositTimeDeposit
		case AccountType.INDIVIDUAL_DEVELOPMENT_ACCOUNT:
			return MismoAssetType.IndividualDevelopmentAccount
		case AccountType.LIFE_INSURANCE:
			return MismoAssetType.LifeInsurance
		case AccountType.MONEY_MARKET_FUND:
			return MismoAssetType.MoneyMarketFund
		case AccountType.MUTUAL_FUND:
			return MismoAssetType.MutualFund
		case AccountType.RETIREMENT_FUND:
			return MismoAssetType.RetirementFund
		case AccountType.SAVINGS_ACCOUNT:
			return MismoAssetType.SavingsAccount
		case AccountType.STOCK:
			return MismoAssetType.Stock
		case AccountType.STOCK_OPTIONS:
			return MismoAssetType.StockOptions
		case AccountType.TRUST_ACCOUNT:
			return MismoAssetType.TrustAccount
		case AccountType.MONEY_MARKET:
			return MismoAssetType.MONEY_MARKET
		case AccountType.CD:
			return MismoAssetType.CD
		case AccountType.INVESTMENT:
			return MismoAssetType.INVESTMENT
		case AccountType.RETIREMENT:
			return MismoAssetType.RETIREMENT
		case AccountType.SAVINGS:
			return MismoAssetType.SavingsAccount
		case AccountType.GIFT_OF_CASH:
			return MismoAssetType.GIFT_OF_CASH
		case AccountType.OTHER:
		default:
			break;
	}
}

export const MortdashHousingStatusToMismoResidencyTypeBasis = (housingStatus: HousingStatus) => {
	switch (housingStatus) {
		case HousingStatus.OWN:
			return MismoResisdencyTypeBasis.Own
		case HousingStatus.RENT:
			return MismoResisdencyTypeBasis.Rent
		case HousingStatus.LIVING_RENT_FREE:
			return MismoResisdencyTypeBasis.LivinRentFree
		default:
			break;
	}
}

export const MortdashStatusTypeToMismoOwnedPropertyDispositionStatusType = (status: PropertyStatus) => {
	switch (status) {
		case PropertyStatus.RETAINED:
			return MismoOwnedPropertyDispositionStatusType.Retained
		case PropertyStatus.PENDING:
			return MismoOwnedPropertyDispositionStatusType.PendingSale
		case PropertyStatus.SOLD:
			return MismoOwnedPropertyDispositionStatusType.Sold
		default:
			break;
	}
}

export const MortdashOccupancyTypeToMismoPropertyUsageType = (occupancyType: OccupancyType) => {
	switch (occupancyType) {
		case OccupancyType.INVESTMENT:
			return MismoPropertyUsageType.Investment
		case OccupancyType.PRIMARY_RESIDENCE:
			return MismoPropertyUsageType.PrimaryResidence
		case OccupancyType.SECOND_HOME:
			return MismoPropertyUsageType.SecondHome
		default:
			break;
	}
}

export const MortdashCollectionMethodToMismoApplicationTakenMethodType = (method: CollectionMethod) => {
	switch (method) {
		case CollectionMethod.FACE_TO_FACE:
			return MismoApplicationTakenMethodType.FaceToFace
		case CollectionMethod.FAX:
			return MismoApplicationTakenMethodType.Fax
		case CollectionMethod.EMAIL:
			return MismoApplicationTakenMethodType.Internet
		case CollectionMethod.TELEPHONE:
			return MismoApplicationTakenMethodType.Telephone
		default:
			break;
	}
}

export const MismoPropertyUsageTypeToMortdashPropertyType = (type: MismoPropertyUsageType) => {
	switch (type) {
		case MismoPropertyUsageType.Investment:
			return PropertyType.INVESTMENT
		case MismoPropertyUsageType.PrimaryResidence:
			return PropertyType.PRIMARY_RESIDENCE
		case MismoPropertyUsageType.SecondHome:
			return PropertyType.SECOND_HOME
		default:
			break;
	}
}

export const MortdashPropertyTypeToMismoPropertyUsageType = (type: PropertyType) => {
	switch (type) {
		case PropertyType.INVESTMENT:
			return MismoPropertyUsageType.Investment
		case PropertyType.PRIMARY_RESIDENCE:
			return MismoPropertyUsageType.PrimaryResidence
		case PropertyType.SECOND_HOME:
			return MismoPropertyUsageType.SecondHome
		default:
			break;
	}
}

export const MismoMaritalStatusToMortdashMaritalStatus = (status: MismoMaritalStatus) => {
	switch (status) {
		case MismoMaritalStatus.Married:
			return MaritalStatus.MARRIED
		case MismoMaritalStatus.Separated:
			return MaritalStatus.SEPARATED
		case MismoMaritalStatus.Unmarried:
			return MaritalStatus.SINGLE
		case MismoMaritalStatus.Divorced:
			return MaritalStatus.DIVORCED
		case MismoMaritalStatus.Widowed:
			return MaritalStatus.WIDOWED
		default:
			break;
	}
}

/**
 * MISMO 3.4 / ULAD `MaritalStatusType` — only these four canonical strings (ULAD: 0–3):
 * Married, NotMarried, Separated, LeaveBlank.
 * Legacy files may use `Unmarried`; treat as NotMarried (portal `SINGLE`). Other legacy values
 * (Divorced, Widowed) map to NotMarried so we never emit non-ULAD marital enums from MISMO import.
 * LeaveBlank → omit (`undefined`).
 */
export const mismo34MaritalStatusTypeToMortdashMaritalStatus = (raw: unknown): MaritalStatus | undefined => {
	if (raw == null) return undefined
	const s = String(raw).trim()
	if (!s) return undefined
	const key = s.replace(/\s+/g, '').toLowerCase()
	if (key === 'married') return MaritalStatus.MARRIED
	if (key === 'notmarried' || key === 'unmarried') return MaritalStatus.SINGLE
	if (key === 'separated') return MaritalStatus.SEPARATED
	if (key === 'leaveblank') return undefined
	if (key === 'divorced' || key === 'widowed') return MaritalStatus.SINGLE
	return undefined
}

export const MortdashMaritalStatusToMismoMaritalStatus = (status: MaritalStatus) => {
	switch (status) {
		case MaritalStatus.MARRIED:
			return MismoMaritalStatus.Married
		case MaritalStatus.SEPARATED:
			return MismoMaritalStatus.Separated
		case MaritalStatus.SINGLE:
			return MismoMaritalStatus.Unmarried
		case MaritalStatus.DIVORCED:
			return MismoMaritalStatus.Divorced
		case MaritalStatus.WIDOWED:
			return MismoMaritalStatus.Widowed
		default:
			break;
	}
}

export const MortdashCitizenshipStatusToMismoCitizenshipResidencyType = (status: CitizenshipStatus) => {
	switch (status) {
		case CitizenshipStatus.US_CITIZEN:
			return MismoCitizenshipResidencyType.U_S_CITIZEN
		case CitizenshipStatus.PERMANENT_RESIDENT:
			return MismoCitizenshipResidencyType.PERMANENT_RESIDENT
		case CitizenshipStatus.NON_PERMANENT_RESIDENT:
			return MismoCitizenshipResidencyType.NON_PERMANENT_RESIDENT
		default:
			return MismoCitizenshipResidencyType.NON_PERMANENT_RESIDENT
			break;
	}
}

export const MismoCitizenshipResidencyTypeToMortdashCitizenshipStatus = (status: MismoCitizenshipResidencyType) => {
	switch (status) {
		case MismoCitizenshipResidencyType.U_S_CITIZEN:
			return CitizenshipStatus.US_CITIZEN
		case MismoCitizenshipResidencyType.PERMANENT_RESIDENT:
			return CitizenshipStatus.PERMANENT_RESIDENT
		case MismoCitizenshipResidencyType.NON_PERMANENT_RESIDENT:
			return CitizenshipStatus.NON_PERMANENT_RESIDENT
		default:
			break;
	}
}

export const MortdashGiftOrGrantSourceTypeToMismoGiftOrGrantSourceType = (source: GiftOrGrantSourceType) => {
	switch (source) {
		case GiftOrGrantSourceType.RELATIVE:
			return MismoGiftOrGrantSourceType.RELATIVE
		case GiftOrGrantSourceType.EMPLOYER:
			return MismoGiftOrGrantSourceType.EMPLOYER
		case GiftOrGrantSourceType.OTHER:
			return MismoGiftOrGrantSourceType.OTHER
		default:
			break;
	}
}

export const MismoGiftOrGrantSourceTypeToMortdashGiftOrGrantSourceType = (source: MismoGiftOrGrantSourceType) => {
	switch (source) {
		case MismoGiftOrGrantSourceType.RELATIVE:
			return GiftOrGrantSourceType.RELATIVE
		case MismoGiftOrGrantSourceType.EMPLOYER:
			return GiftOrGrantSourceType.EMPLOYER
		default:
			return GiftOrGrantSourceType.OTHER
	}
}
export const MismoLiabilityTypeToMortdashLiabilityType = (type: MismoLiabilityType) => {
	switch (type) {
		case MismoLiabilityType.MORTGAGE:
			return LiabilityType.MORTGAGE
		case MismoLiabilityType.HELOC:
			return LiabilityType.HELOC
		case MismoLiabilityType.CAR_LOAN:
			return LiabilityType.CAR_LOAN
		case MismoLiabilityType.STUDENT_LOAN:
			return LiabilityType.STUDENT_LOAN
		case MismoLiabilityType.CREDIT_CARD:
			return LiabilityType.CREDIT_CARD
		case MismoLiabilityType.OTHER:
			return LiabilityType.OTHER
		default:
			break;
	}
}
export const MortdashLiabilityTypeToMismoLiabilityType = (type: LiabilityType) => {
	switch (type) {
		case LiabilityType.MORTGAGE:
			return MismoLiabilityType.MORTGAGE
		case LiabilityType.HELOC:
			return MismoLiabilityType.HELOC
		case LiabilityType.CAR_LOAN:
			return MismoLiabilityType.CAR_LOAN
		case LiabilityType.STUDENT_LOAN:
			return MismoLiabilityType.STUDENT_LOAN
		case LiabilityType.CREDIT_CARD:
			return MismoLiabilityType.CREDIT_CARD
		case LiabilityType.OTHER:
			return MismoLiabilityType.OTHER
		default:
			break;
	}
}

export const MortdashHousingExpenseTypeToMismoHousingExpenseType = (type: HousingExpenseType) => {
	switch (type) {
		case HousingExpenseType.FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST:
			return MismoHousingExpenseType.FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST
		case HousingExpenseType.HOMEOWNERS_INSURANCE:
			return MismoHousingExpenseType.HOMEOWNERS_INSURANCE
		case HousingExpenseType.REAL_ESTATE_TAX:
			return MismoHousingExpenseType.REAL_ESTATE_TAX
		case HousingExpenseType.MI_PREMIUM:
			return MismoHousingExpenseType.MI_PREMIUM
		case HousingExpenseType.HOMEOWNERS_ASSOCIATION_DUES_AND_CONDOMINIUM_FEES:
			return MismoHousingExpenseType.HOMEOWNERS_ASSOCIATION_DUES_AND_CONDOMINIUM_FEES
		case HousingExpenseType.OTHER_MORTGAGE_LOAN_PRINCIPAL_AND_INTEREST:
			return MismoHousingExpenseType.OTHER_MORTGAGE_LOAN_PRINCIPAL_AND_INTEREST
		case HousingExpenseType.OTHER:
			return MismoHousingExpenseType.OTHER
		default:
			break;
	}
}

export const MismoHousingExpenseTypeToMortdashHousingExpenseType = (type: MismoHousingExpenseType) => {
	switch (type) {
		case MismoHousingExpenseType.FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST:
			return HousingExpenseType.FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST
		case MismoHousingExpenseType.HOMEOWNERS_INSURANCE:
			return HousingExpenseType.HOMEOWNERS_INSURANCE
		case MismoHousingExpenseType.REAL_ESTATE_TAX:
			return HousingExpenseType.REAL_ESTATE_TAX
		case MismoHousingExpenseType.MI_PREMIUM:
			return HousingExpenseType.MI_PREMIUM
		case MismoHousingExpenseType.HOMEOWNERS_ASSOCIATION_DUES_AND_CONDOMINIUM_FEES:
			return HousingExpenseType.HOMEOWNERS_ASSOCIATION_DUES_AND_CONDOMINIUM_FEES
		case MismoHousingExpenseType.OTHER_MORTGAGE_LOAN_PRINCIPAL_AND_INTEREST:
			return HousingExpenseType.OTHER_MORTGAGE_LOAN_PRINCIPAL_AND_INTEREST
		case MismoHousingExpenseType.OTHER:
			return HousingExpenseType.OTHER
		default:
			break;
	}
}

export const MortdashHousingExpenseTimingTypeToMismoHousingExpenseTimingType = (type: HousingExpenseTimingType) => {
	switch (type) {
		case HousingExpenseTimingType.PROPOSED:
		return MismoHousingExpenseTimingType.PROPOSED
		default:
			break
	}
}

export const MismoHousingExpenseTimingTypeToMortdashHousingExpenseTimingType = (type: MismoHousingExpenseTimingType) => {
	switch (type) {
		case MismoHousingExpenseTimingType.PROPOSED:
		return HousingExpenseTimingType.PROPOSED
		default:
			break
	}
}

export const MeridianPropertyTypeToMortdashPropertyType = (type: MeridianPropertyType): PortalPropertyType => {
	switch (type) {
		case MeridianPropertyType.SFR:
			return PortalPropertyType.SFR;
		case MeridianPropertyType.PUD:
			return PortalPropertyType.PUD;
		case MeridianPropertyType.CONDO:
			return PortalPropertyType.CONDO;
		case MeridianPropertyType.COOP:
			return PortalPropertyType.COOP;
		case MeridianPropertyType.MANUFACTURED:
			return PortalPropertyType.MANUFACTURED;
		case MeridianPropertyType.TWO_UNITS:
		case MeridianPropertyType.THREE_UNITS:
		case MeridianPropertyType.FOUR_UNITS:
			return PortalPropertyType.TWO_TO_FOUR_UNIT;
		case MeridianPropertyType.MODULAR:
			return PortalPropertyType.MODULAR;
		case MeridianPropertyType.ROWHOUSE:
			return PortalPropertyType.SFR; // ROWHOUSE maps to SFR as it's not explicitly defined in portal types
		default:
			throw new Error(`Unknown MeridianPropertyType: ${type}`);
	}
};

export const PortalPropertyTypeToMeridianPropertyType = (type: PortalPropertyType): MeridianPropertyType => {
	switch (type) {
		case PortalPropertyType.SFR:
			return MeridianPropertyType.SFR;
		case PortalPropertyType.PUD:
			return MeridianPropertyType.PUD;
		case PortalPropertyType.CONDO:
			return MeridianPropertyType.CONDO;
		case PortalPropertyType.COOP:
			return MeridianPropertyType.COOP;
		case PortalPropertyType.MANUFACTURED:
			return MeridianPropertyType.MANUFACTURED;
		case PortalPropertyType.TWO_TO_FOUR_UNIT:
			return MeridianPropertyType.TWO_UNITS; // Default to TWO_UNITS for 2-4 unit properties
		case PortalPropertyType.MODULAR:
			return MeridianPropertyType.MODULAR;
		case PortalPropertyType.NON_WARRANTABLE_CONDO:
			return MeridianPropertyType.CONDO; // Map non-warrantable condo to regular condo
		default:
			break
	}
};

export const MeridianLoanPurposeToPortalLoanPurpose = (meridianType: MeridianLoanPurposeType): PortalLoanPurposeType => {
	switch (meridianType) {
		case MeridianLoanPurposeType.Purchase:
			return PortalLoanPurposeType.Purchase;
		case MeridianLoanPurposeType.Refinance:
			return PortalLoanPurposeType.Refinance;
		case MeridianLoanPurposeType.RefinanceCashout:
			return PortalLoanPurposeType.RefinanceCashout;
		case MeridianLoanPurposeType.Construct:
			return PortalLoanPurposeType.Construct;
		case MeridianLoanPurposeType.ConstructPermanent:
			return PortalLoanPurposeType.ConstructPermanent;
		case MeridianLoanPurposeType.FHAStreamlinedRefinance:
			return PortalLoanPurposeType.FHAStreamlinedRefinance;
		case MeridianLoanPurposeType.VAIRRRL:
			return PortalLoanPurposeType.VAIRRRL;
		case MeridianLoanPurposeType.HomeEquity:
			return PortalLoanPurposeType.HomeEquity;
		case MeridianLoanPurposeType.Other:
			return PortalLoanPurposeType.Other;
		default:
			throw new Error(`Unknown MeridianLoanPurposeType: ${meridianType}`);
	}
};

export const PortalLoanPurposeToMeridianLoanPurpose = (portalType: PortalLoanPurposeType): MeridianLoanPurposeType => {
	switch (portalType) {
		case PortalLoanPurposeType.Purchase:
			return MeridianLoanPurposeType.Purchase;
		case PortalLoanPurposeType.RTRefinance:
			return MeridianLoanPurposeType.Refinance;
		case PortalLoanPurposeType.Cashout:
			return MeridianLoanPurposeType.RefinanceCashout;
		default:
			return MeridianLoanPurposeType.Purchase; // Default fallback
	}
}; 

export const MeridianOccupancyTypeToPortalOccupancyTYpe = (meridianType: MeridianOccupancyType): PortalOccupancyType => {
	switch (meridianType) {
		case MeridianOccupancyType.PrimaryResidence:
			return PortalOccupancyType.Primary;
		case MeridianOccupancyType.SecondaryResidence:
			return PortalOccupancyType.SecondHome;
		case MeridianOccupancyType.Investment:
			return PortalOccupancyType.Investment;
		default:
			throw new Error(`Unknown MeridianOccupancyType: ${meridianType}`);
	}
}

export const MeridianOccupancyTypeToPortalOccupancyTypeCOC = (meridianType: MeridianOccupancyType): PortalOccupancyTypeCOC => {
	switch (meridianType) {
		case MeridianOccupancyType.PrimaryResidence:
			return PortalOccupancyTypeCOC.PrimaryResidence;
		case MeridianOccupancyType.SecondaryResidence:
			return PortalOccupancyTypeCOC.SecondaryResidence;
		case MeridianOccupancyType.Investment:
			return PortalOccupancyTypeCOC.Investment;
		default:
			throw new Error(`Unknown MeridianOccupancyType: ${meridianType}`);
	}
}

export const PortalOccupancyTypeToMeridianOccupancyTYpe = (portalType: PortalOccupancyType): MeridianOccupancyType => {
	switch (portalType) {
		case PortalOccupancyType.Primary:
			return MeridianOccupancyType.PrimaryResidence;
		case PortalOccupancyType.SecondHome:
			return MeridianOccupancyType.SecondaryResidence;
		case PortalOccupancyType.Investment:
			return MeridianOccupancyType.Investment;
		default:
			throw new Error(`Unknown PortalOccupancyType: ${portalType}`);
	}
}

/**
 * Convert numeric loan purpose value to descriptive string
 */
export const MeridianLoanPurposeTypeToMeridianLoanPurposeTextType = (purposeValue: string): MeridianLoanPurposeTextType => {
	switch (purposeValue) {
		case '0':
			return MeridianLoanPurposeTextType.PURCHASE;
		case '1':
			return MeridianLoanPurposeTextType.REFI_RATE_TERM;
		case '2':
			return MeridianLoanPurposeTextType.REFINANCE_CASHOUT;
		case '3':
			return MeridianLoanPurposeTextType.CONSTRUCTION;
		case '4':
			return MeridianLoanPurposeTextType.CONSTRUCTION_PERM;
		case '5':
			return MeridianLoanPurposeTextType.OTHER;
		case '6':
			return MeridianLoanPurposeTextType.FHA_STREAMLINE_REFI;
		case '7':
			return MeridianLoanPurposeTextType.VA_IRRRL;
		default:
			return MeridianLoanPurposeTextType.UNKNOWN;
	}
};

export const MeridianKeyDatesTypeToMortdashKeyDateType = (baseName: MeridianKeyDatesType): PortalKeyDatesType => {
	switch (baseName) {
	  case MeridianKeyDatesType.S_LEAD:
		return PortalKeyDatesType.LEAD;
	  case MeridianKeyDatesType.S_OPENED:
		return PortalKeyDatesType.OPENED;
	  case MeridianKeyDatesType.S_PREQUAL:
		return PortalKeyDatesType.PRE_QUALIFICATION;
	  case MeridianKeyDatesType.S_SUBMIT:
		return PortalKeyDatesType.REGISTERED;
	  case MeridianKeyDatesType.S_PREPROCESSING:
		return PortalKeyDatesType.PRE_PROCESSING;
	  case MeridianKeyDatesType.S_PROCESSING:
		return PortalKeyDatesType.PROCESSING;
	  case MeridianKeyDatesType.S_DOCUMENTCHECK:
		return PortalKeyDatesType.DOCUMENT_CHECK;
	  case MeridianKeyDatesType.S_DOCUMENTCHECKFAILED:
		return PortalKeyDatesType.DOCUMENT_CHECK_FAILED;
	  case MeridianKeyDatesType.S_LOANSUBMITTED:
		return PortalKeyDatesType.LOAN_SUBMITTED;
	  case MeridianKeyDatesType.S_PREUNDERWRITING:
		return PortalKeyDatesType.PRE_UNDERWRITING;
	  case MeridianKeyDatesType.S_UNDERWRITING:
		return PortalKeyDatesType.UNDERWRITING;
	  case MeridianKeyDatesType.S_PREAPPROV:
		return PortalKeyDatesType.PRE_APPROVAL;
	  case MeridianKeyDatesType.S_APPROV:
		return PortalKeyDatesType.APPROVED;
	  case MeridianKeyDatesType.S_CONDITIONREVIEW:
		return PortalKeyDatesType.CONDITION_REVIEW;
	  case MeridianKeyDatesType.S_FINALUNDERWRITING:
		return PortalKeyDatesType.FINAL_UNDERWRITING;
	  case MeridianKeyDatesType.S_PREDOCQC:
		return PortalKeyDatesType.PRE_DOC_QC;
	  case MeridianKeyDatesType.S_CLEARTOCLOSE:
		return PortalKeyDatesType.CLEAR_TO_CLOSE;
	  case MeridianKeyDatesType.S_DOCSORDERED:
		return PortalKeyDatesType.DOCS_ORDERED;
	  case MeridianKeyDatesType.S_DOCSDRAWN:
		return PortalKeyDatesType.DOC_DRAWN;
	  case MeridianKeyDatesType.S_DOCS:
		return PortalKeyDatesType.DOCS_OUT;
	  case MeridianKeyDatesType.S_DOCSBACK:
		return PortalKeyDatesType.DOCS_BACK;
	  case MeridianKeyDatesType.S_FUNDINGCONDITIONS:
		return PortalKeyDatesType.FUNDING_CONDITIONS;
	  case MeridianKeyDatesType.S_FUND:
		return PortalKeyDatesType.FUNDED;
	  case MeridianKeyDatesType.S_RECORDED:
		return PortalKeyDatesType.RECORDED;
	  case MeridianKeyDatesType.S_FINALDOCS:
		return PortalKeyDatesType.FINAL_DOCS;
	  case MeridianKeyDatesType.S_CLOSED:
		return PortalKeyDatesType.CLOSED;
	  case MeridianKeyDatesType.S_SUBMITTEDFORPURCHASEREVIEW:
		return PortalKeyDatesType.SUBMITTED_FOR_PURCHASE_REVIEW;
	  case MeridianKeyDatesType.S_INPURCHASEREVIEW:
		return PortalKeyDatesType.IN_PURCHASE_REVIEW;
	  case MeridianKeyDatesType.S_PREPURCHASECONDITIONS:
		return PortalKeyDatesType.PRE_PURCHASE_CONDITIONS;
	  case MeridianKeyDatesType.S_SUBMITTEDFORFINALPURCHASE:
		return PortalKeyDatesType.SUBMITTED_FOR_FINAL_PURCHASE;
	  case MeridianKeyDatesType.S_INFINALPURCHASEREVIEW:
		return PortalKeyDatesType.IN_FINAL_PURCHASE_REVIEW;
	  case MeridianKeyDatesType.S_CLEARTOPURCHASE:
		return PortalKeyDatesType.CLEAR_TO_PURCHASE;
	  case MeridianKeyDatesType.S_PURCHASED:
		return PortalKeyDatesType.PURCHASED;
	  case MeridianKeyDatesType.S_READYFORSALE:
		return PortalKeyDatesType.READY_FOR_SALE;
	  case MeridianKeyDatesType.S_SHIPPEDTOINVESTOR:
		return PortalKeyDatesType.SHIPPED_TO_INVESTOR;
	  case MeridianKeyDatesType.S_SUSPENDEDBYINVESTOR:
		return PortalKeyDatesType.SUSPENDED_BY_INVESTOR;
	  case MeridianKeyDatesType.S_ADDITIONALCONDSENT:
		return PortalKeyDatesType.ADDITIONAL_COND_SENT;
	  case MeridianKeyDatesType.S_LPURCHASE:
		return PortalKeyDatesType.LOAN_PURCHASE;
	  case MeridianKeyDatesType.S_COUNTEROFFER:
		return PortalKeyDatesType.COUNTER_OFFER;
	  case MeridianKeyDatesType.S_ONHOLD:
		return PortalKeyDatesType.ON_HOLD;
	  case MeridianKeyDatesType.S_CANCELED:
		return PortalKeyDatesType.CANCELED;
	  case MeridianKeyDatesType.S_SUSPENDED:
		return PortalKeyDatesType.SUSPENDED;
	  case MeridianKeyDatesType.S_REJECT:
		return PortalKeyDatesType.REJECT;
	  case MeridianKeyDatesType.S_WITHDRAWN:
		return PortalKeyDatesType.WITHDRAWN;
	  case MeridianKeyDatesType.S_ARCHIVED:
		return PortalKeyDatesType.ARCHIVED;
	  case MeridianKeyDatesType.S_QCCOMP:
		return PortalKeyDatesType.QC_COMPLETION;
	  case MeridianKeyDatesType.S_INITAL_LOAN_ESTIMATE_ISSUED:
		return PortalKeyDatesType.INITIAL_LE_SENT;
	  case MeridianKeyDatesType.S_INITAL_LOAN_ESTIMATE_SIGNED:
		return PortalKeyDatesType.INITIAL_LE_SIGNED;
	  case MeridianKeyDatesType.S_LAST_DISCLOSED_LOAN_ESTIMATE_ISSUED:
		return PortalKeyDatesType.LATEST_LE_SENT;
	  case MeridianKeyDatesType.S_LAST_DISCLOSED_LOAN_ESTIMATE_SIGNED:
		return PortalKeyDatesType.LATEST_LE_SIGNED;
	  case MeridianKeyDatesType.S_INITIAL_CLOSING_DISCLOSURE_ISSUED:
		return PortalKeyDatesType.INITIAL_CD_SENT;
	  case MeridianKeyDatesType.S_INITIAL_CLOSING_DISCLOSURE_SIGNED:
		return PortalKeyDatesType.INITIAL_CD_SIGNED;
	  case MeridianKeyDatesType.S_LAST_CLOSING_DISCLOSURE_BEFORE_CONSUMMATION_ISSUED:
		return PortalKeyDatesType.LATEST_CD_SENT;
	  case MeridianKeyDatesType.S_LAST_CLOSING_DISCLOSURE_BEFORE_CONSUMMATION_SIGNED:
		return PortalKeyDatesType.LATEST_CD_SIGNED;
	  case MeridianKeyDatesType.S_RLCKDEXPIRED:
		return PortalKeyDatesType.RATE_LOCK_EXPIRATION;
	  default:
		return PortalKeyDatesType.LEAD; // Return a valid enum value instead of empty string
	}
}

export const MeridianStateTypeToMeridianCountyType = (state: MeridianStateType) => {
	switch (state) {
		case MeridianStateType.AK:
			return AK_CountyType;
		case MeridianStateType.AL:
			return AL_CountyType;
		case MeridianStateType.AR:
			return AR_CountyType;
		case MeridianStateType.AZ:
			return AZ_CountyType;
		case MeridianStateType.CA:
			return CA_CountyType;
		case MeridianStateType.CO:
			return CO_CountyType;
		case MeridianStateType.CT:
			return CT_CountyType;
		case MeridianStateType.DE:
			return DE_CountyType;
		case MeridianStateType.FL:
			return FL_CountyType;
		case MeridianStateType.GA:
			return GA_CountyType;
		case MeridianStateType.HI:
			return HI_CountyType;
		case MeridianStateType.IA:
			return IA_CountyType;
		case MeridianStateType.ID:
			return ID_CountyType;
		case MeridianStateType.IL:
			return IL_CountyType;
		case MeridianStateType.IN:
			return IN_CountyType;
		case MeridianStateType.KS:
			return KS_CountyType;
		case MeridianStateType.KY:
			return KY_CountyType;
		case MeridianStateType.LA:
			return LA_CountyType;
		case MeridianStateType.MA:
			return MA_CountyType;
		case MeridianStateType.MD:
			return MD_CountyType;
		case MeridianStateType.ME:
			return ME_CountyType;
		case MeridianStateType.MI:
			return MI_CountyType;
		case MeridianStateType.MN:
			return MN_CountyType;
		case MeridianStateType.MO:
			return MO_CountyType;
		case MeridianStateType.MS:
			return MS_CountyType;
		case MeridianStateType.MT:
			return MT_CountyType;
		case MeridianStateType.NC:
			return NC_CountyType;
		case MeridianStateType.ND:
			return ND_CountyType;
		case MeridianStateType.NE:
			return NE_CountyType;
		case MeridianStateType.NH:
			return NH_CountyType;
		case MeridianStateType.NJ:
			return NJ_CountyType;
		case MeridianStateType.NM:
			return NM_CountyType;
		case MeridianStateType.NV:
			return NV_CountyType;
		case MeridianStateType.NY:
			return NY_CountyType;
		case MeridianStateType.OH:
			return OH_CountyType;
		case MeridianStateType.OK:
			return OK_CountyType;
		case MeridianStateType.OR:
			return OR_CountyType;
		case MeridianStateType.PA:
			return PA_CountyType;
		case MeridianStateType.RI:
			return RI_CountyType;
		case MeridianStateType.SC:
			return SC_CountyType;
		case MeridianStateType.SD:
			return SD_CountyType;
		case MeridianStateType.TN:
			return TN_CountyType;
		case MeridianStateType.TX:
			return TX_CountyType;
		case MeridianStateType.UT:
			return UT_CountyType;
		case MeridianStateType.VA:
			return VA_CountyType;
		case MeridianStateType.VT:
			return VT_CountyType;
		case MeridianStateType.WA:
			return WA_CountyType;
		case MeridianStateType.WI:
			return WI_CountyType;
		case MeridianStateType.WV:
			return WV_CountyType;
		case MeridianStateType.WY:
			return WY_CountyType;
		default:
			throw new Error(`Unknown State: ${state}`);
	}
}

export const PortalModeTypeToMeridianPortalModeType = (type: PortalModeType): MeridianPortalModeType => {
	switch (type) {
		case PortalModeType.BROKER:
			return MeridianPortalModeType.WHOLESALE;
		case PortalModeType.MINI_CORRESPONDENT:
			return MeridianPortalModeType.NON_DEL_COR;
		case PortalModeType.CORRESPONDENT:
			return MeridianPortalModeType.COR;
		default:
			throw new Error(`Invalid PortalModeType: ${type}`);
	}
}

export const MeridianPortalModeTypeToPortalModeType = (type: MeridianPortalModeType): PortalModeType => {
	switch (type) {
		case MeridianPortalModeType.WHOLESALE:
			return PortalModeType.BROKER;
		case MeridianPortalModeType.NON_DEL_COR:
			return PortalModeType.MINI_CORRESPONDENT;
		case MeridianPortalModeType.COR:
			return PortalModeType.CORRESPONDENT;
		default:
			throw new Error(`Invalid MeridianPortalModeType: ${type}`);
	}
}

/**
 * Convert numeric citizenship value or enum value to label string
 */
export const PortalCitizenshipTypeToPortalCitizenshipTextType = (value: string | number): string => {
	// Handle numeric values (0, 1, 2, 3)
	if (typeof value === 'number') {
		value = value.toString();
	}
	
	switch (value) {
		case '0':
		case PortalCitizenshipType.US_CITIZEN:
			return PortalCitizenshipType.US_CITIZEN;
		case '1':
		case PortalCitizenshipType.PERMANENT_RESIDENT:
			return PortalCitizenshipType.PERMANENT_RESIDENT;
		case '2':
		case PortalCitizenshipType.NON_PERMANENT_RESIDENT:
			return PortalCitizenshipType.NON_PERMANENT_RESIDENT;
		case '3':
		case PortalCitizenshipType.FOREIGN_NATIONAL:
			return PortalCitizenshipType.FOREIGN_NATIONAL;
		default:
			// If it's already a label, return it as is
			if (Object.values(PortalCitizenshipType).includes(value as PortalCitizenshipType)) {
				return value as string;
			}
			return PortalCitizenshipType.US_CITIZEN; // Default fallback
	}
}

/**
 * Convert numeric property type value to label string
 */
export const PortalPropertyTypeToPortalPropertyTextType = (value: string | number): string => {
	// Handle numeric values
	if (typeof value === 'number') {
		value = value.toString();
	}
	
	switch (value) {
		case '0':
			return PortalPropertyType.SFR;
		case '1':
			return PortalPropertyType.PUD;
		case '2':
			return PortalPropertyType.CONDO;
		case '3':
			return PortalPropertyType.COOP;
		case '4':
			return PortalPropertyType.MANUFACTURED;
		case '8':
			return PortalPropertyType.TWO_UNITS;
		case '9':
			return PortalPropertyType.THREE_UNITS;
		case '10':
			return PortalPropertyType.FOUR_UNITS;
		case '11':
			return PortalPropertyType.MODULAR;
		case '12':
			return PortalPropertyType.ROWHOUSE;
		case '13':
			return PortalPropertyType.LAND;
		default:
			// If it's already a label, return it as is
			if (Object.values(PortalPropertyType).includes(value as PortalPropertyType)) {
				return value as string;
			}
			return PortalPropertyType.SFR; // Default fallback
	}
}

/**
 * Convert numeric structure type value to label string
 */
export const PortalStructureTypeToPortalStructureTextType = (value: string | number): string => {
	// Handle numeric values
	if (typeof value === 'number') {
		value = value.toString();
	}
	
	switch (value) {
		case '1':
		case PortalStructureType.ATTACHED:
			return PortalStructureType.ATTACHED;
		case '2':
		case PortalStructureType.DETACHED:
			return PortalStructureType.DETACHED;
		default:
			// If it's already a label, return it as is
			if (Object.values(PortalStructureType).includes(value as PortalStructureType)) {
				return value as string;
			}
			return PortalStructureType.DETACHED; // Default fallback
	}
}

/**
 * Convert numeric occupancy type value to label string
 */
export const PortalOccupancyTypeToPortalOccupancyTextType = (value: string | number): string => {
	// Handle numeric values
	if (typeof value === 'number') {
		value = value.toString();
	}
	
	switch (value) {
		case '0':
		case PortalOccupancyTypeCOC.PrimaryResidence:
			return PortalOccupancyTypeCOC.PrimaryResidence;
		case '1':
		case PortalOccupancyTypeCOC.SecondaryResidence:
			return PortalOccupancyTypeCOC.SecondaryResidence;
		case '2':
		case PortalOccupancyTypeCOC.Investment:
			return PortalOccupancyTypeCOC.Investment;
		default:
			// If it's already a label, return it as is
			if (Object.values(PortalOccupancyTypeCOC).includes(value as PortalOccupancyTypeCOC)) {
				return value as string;
			}
			return PortalOccupancyTypeCOC.PrimaryResidence; // Default fallback
	}
}

/**
 * Convert lender fee buyout requested type value to text string
 */
export const LenderFeeBuyoutRequestedTypeToTextType = (value: string | number): string => {
	// Handle numeric values
	if (typeof value === 'number') {
		value = value.toString();
	}
	
	switch (value) {
		case '0':
			return 'No';
		case '1':
			return 'Yes';
		case '2':
			return 'Waived';
		default:
			return 'No'; // Default fallback
	}
}

export const OriginatorCompensationPaymentSourceTypeToTextType = (value: string | number): string => {
	// Handle numeric values
	if (typeof value === 'number') {
		value = value.toString();
	}
	
	switch (value) {
		case '1':
			return 'Borrower Paid';
		case '2':
			return 'Lender Paid';
		default:
			return 'N/A'; // Default fallback
	}
}

export const PricingImpoundTypeToTextType = (value: string | number) => {
	// Handle numeric values
	if (typeof value === 'number') {
		value = value.toString();
	}
	
	switch (value) {
		case '0':
			return PricingImpoundTypeText.TAX_AND_INSURANCE_ESCROW;
		case '1':
			return PricingImpoundTypeText.TAX_ESCROW_ONLY;
		case '2':
			return PricingImpoundTypeText.INSURANCE_ESCROW_ONLY;
		case '3':
			return PricingImpoundTypeText.NO_ESCROW;
		default:
			return '';
	}
}

export const MismoIncomeSourceTypeToMonthlyIncomeType = (incomeType: MismoIncomeSourceType2 | string): LoanEmploymentMonthlyIncomeType => {
	const typeMap: Record<string, LoanEmploymentMonthlyIncomeType> = {
	  [MismoIncomeSourceType2.BASE_INCOME]: LoanEmploymentMonthlyIncomeType.BASE_INCOME,
	  [MismoIncomeSourceType2.OVERTIME]: LoanEmploymentMonthlyIncomeType.OVERTIME,
	  [MismoIncomeSourceType2.BONUSES]: LoanEmploymentMonthlyIncomeType.BONUSES,
	  [MismoIncomeSourceType2.COMMISSION]: LoanEmploymentMonthlyIncomeType.COMMISSION,
	  [MismoIncomeSourceType2.CONTRACT_BASIS]: LoanEmploymentMonthlyIncomeType.CONTRACT_BASIS,
	  [MismoIncomeSourceType2.MILITARY_BASE_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_BASE_PAY,
	  [MismoIncomeSourceType2.MILITARY_CLOTHES_ALLOWANCE]: LoanEmploymentMonthlyIncomeType.MILITARY_CLOTHES_ALLOWANCE,
	  [MismoIncomeSourceType2.MILITARY_COMBAT_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_COMBAT_PAY,
	  [MismoIncomeSourceType2.MILITARY_FLIGHT_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_FLIGHT_PAY,
	  [MismoIncomeSourceType2.MILITARY_HAZARD_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_HAZARD_PAY,
	  [MismoIncomeSourceType2.MILITARY_OVERSEAS_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_OVERSEAS_PAY,
	  [MismoIncomeSourceType2.MILITARY_PROP_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_PROP_PAY,
	  [MismoIncomeSourceType2.MILITARY_QUARTERS_ALLOWANCE]: LoanEmploymentMonthlyIncomeType.MILITARY_QUARTERS_ALLOWANCE,
	  [MismoIncomeSourceType2.MILITARY_RATIONS_ALLOWANCE]: LoanEmploymentMonthlyIncomeType.MILITARY_RATIONS_ALLOWANCE,
	  [MismoIncomeSourceType2.MILITARY_VARIABLE_HOUSING_ALLOWANCE]: LoanEmploymentMonthlyIncomeType.MILITARY_VARIABLE_HOUSING_ALLOWANCE,
	  [MismoIncomeSourceType2.OTHER]: LoanEmploymentMonthlyIncomeType.OTHER_EMPLOYMENT,
	  [LoanEmploymentMonthlyIncomeType.BASE_INCOME]: LoanEmploymentMonthlyIncomeType.BASE_INCOME,
	  [LoanEmploymentMonthlyIncomeType.OVERTIME]: LoanEmploymentMonthlyIncomeType.OVERTIME,
	  [LoanEmploymentMonthlyIncomeType.BONUSES]: LoanEmploymentMonthlyIncomeType.BONUSES,
	  [LoanEmploymentMonthlyIncomeType.COMMISSION]: LoanEmploymentMonthlyIncomeType.COMMISSION,
	  [LoanEmploymentMonthlyIncomeType.CONTRACT_BASIS]: LoanEmploymentMonthlyIncomeType.CONTRACT_BASIS,
	  [LoanEmploymentMonthlyIncomeType.MILITARY_BASE_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_BASE_PAY,
	  [LoanEmploymentMonthlyIncomeType.MILITARY_CLOTHES_ALLOWANCE]: LoanEmploymentMonthlyIncomeType.MILITARY_CLOTHES_ALLOWANCE,
	  [LoanEmploymentMonthlyIncomeType.MILITARY_COMBAT_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_COMBAT_PAY,
	  [LoanEmploymentMonthlyIncomeType.MILITARY_FLIGHT_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_FLIGHT_PAY,
	  [LoanEmploymentMonthlyIncomeType.MILITARY_HAZARD_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_HAZARD_PAY,
	  [LoanEmploymentMonthlyIncomeType.MILITARY_OVERSEAS_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_OVERSEAS_PAY,
	  [LoanEmploymentMonthlyIncomeType.MILITARY_PROP_PAY]: LoanEmploymentMonthlyIncomeType.MILITARY_PROP_PAY,
	  [LoanEmploymentMonthlyIncomeType.MILITARY_QUARTERS_ALLOWANCE]: LoanEmploymentMonthlyIncomeType.MILITARY_QUARTERS_ALLOWANCE,
	  [LoanEmploymentMonthlyIncomeType.MILITARY_RATIONS_ALLOWANCE]: LoanEmploymentMonthlyIncomeType.MILITARY_RATIONS_ALLOWANCE,
	  [LoanEmploymentMonthlyIncomeType.MILITARY_VARIABLE_HOUSING_ALLOWANCE]: LoanEmploymentMonthlyIncomeType.MILITARY_VARIABLE_HOUSING_ALLOWANCE,
	  [LoanEmploymentMonthlyIncomeType.OTHER_EMPLOYMENT]: LoanEmploymentMonthlyIncomeType.OTHER_EMPLOYMENT,
	}
	
	console.log('Mapping income type:', incomeType, 'to:', typeMap[incomeType] || LoanEmploymentMonthlyIncomeType.OTHER_EMPLOYMENT)
	return typeMap[incomeType] || LoanEmploymentMonthlyIncomeType.OTHER_EMPLOYMENT
  }

  // Reverse mapping for MISMO Income Source Type to Application Other Income Type
export const MismoIncomeSourceTypeToOtherIncomeType = (mismoType: MismoIncomeSourceType | string): LoanOtherIncomeType | LoanEmploymentMonthlyIncomeType => {
	const typeMap: Record<string, LoanOtherIncomeType | LoanEmploymentMonthlyIncomeType> = {
	  // Direct mappings for specific MISMO other income types
	  'Alimony': LoanOtherIncomeType.ALIMONY,
	  'ChildSupport': LoanOtherIncomeType.CHILD_SUPPORT,
	  'Disability': LoanOtherIncomeType.DISABILITY,
	  'DividendsInterest': LoanOtherIncomeType.DIVIDENDS_OR_INTEREST,
	  'ForeignIncome': LoanOtherIncomeType.FOREIGN_INCOME,
	  'Miscellaneous': LoanOtherIncomeType.MISCELLANEOUS_INCOME,
	  'OtherNonEmployment': LoanOtherIncomeType.OTHER_NON_EMPLOYMENT,
	  'PublicAssistance': LoanOtherIncomeType.PUBLIC_ASSISTANCE,
	  'Retirement': LoanOtherIncomeType.RETIREMENT,
	  'RoyaltyPayment': LoanOtherIncomeType.ROYALTY_PAYMENT,
	  'SeasonalIncome': LoanOtherIncomeType.SEASONAL_INCOME,
	  'SeparateMaintenance': LoanOtherIncomeType.SEPARATE_MAINTENANCE,
	  'SocialSecurity': LoanOtherIncomeType.SOCIAL_SECURITY,
	  'SocialSecurityDisability': LoanOtherIncomeType.SOCIAL_SECURITY_DISABILITY,
	  'TipIncome': LoanOtherIncomeType.TIP_INCOME,
	  'Trust': LoanOtherIncomeType.TRUST,
	  'Unemployment': LoanOtherIncomeType.UNEMPLOYMENT,
	  'VACompensation': LoanOtherIncomeType.VA_COMPENSATION,
	  'WorkersCompensation': LoanOtherIncomeType.WORKERS_COMPENSATION,
	  
	  // Additional MISMO other income types
	  'AccessoryUnitIncome': LoanOtherIncomeType.ACCESSORY_UNIT_INCOME,
	  'AutomobileAllowance': LoanOtherIncomeType.AUTOMOBILE_ALLOWANCE,
	  'BoarderIncome': LoanOtherIncomeType.BOARDER_INCOME,
	  'CapitalGains': LoanOtherIncomeType.CAPITAL_GAINS,
	  'DefinedContributionPlan': LoanOtherIncomeType.DEFINED_CONTRIBUTION_PLAN,
	  'EmploymentRelatedAssets': LoanOtherIncomeType.EMPLOYMENT_RELATED_ASSETS,
	  'FosterCare': LoanOtherIncomeType.FOSTER_CARE,
	  'HousingChoiceVoucher': LoanOtherIncomeType.HOUSING_CHOICE_VOUCHER,
	  'HousingOrParsonage': LoanOtherIncomeType.HOUSING_OR_PARSONAGE,
	  'MortgageCreditCertificate': LoanOtherIncomeType.MORTGAGE_CREDIT_CERTIFICATE,
	  'MortgageDifferentialPayment': LoanOtherIncomeType.MORTGAGE_DIFFERENTIAL_PAYMENT,
	  'NonBorrowerHouseholdIncome': LoanOtherIncomeType.NON_BORROWER_HOUSEHOLD_INCOME,
	  'NotesReceivable': LoanOtherIncomeType.NOTES_RECEIVABLE,
	  'TemporaryLeave': LoanOtherIncomeType.TEMPORARY_LEAVE,
	  'TrailingCoBorrowerIncome': LoanOtherIncomeType.TRAILING_CO_BORROWER_INCOME,
	  
	  // Employment income types that might appear in other income context
	  'Base': LoanEmploymentMonthlyIncomeType.BASE_INCOME,
	  'Overtime': LoanEmploymentMonthlyIncomeType.OVERTIME,
	  'Bonus': LoanEmploymentMonthlyIncomeType.BONUSES,
	  'Commission': LoanEmploymentMonthlyIncomeType.COMMISSION,
	  'Contract': LoanEmploymentMonthlyIncomeType.CONTRACT_BASIS,
	  'MilitaryBase': LoanEmploymentMonthlyIncomeType.MILITARY_BASE_PAY,
	  'MilitaryClothing': LoanEmploymentMonthlyIncomeType.MILITARY_CLOTHES_ALLOWANCE,
	  'MilitaryCombat': LoanEmploymentMonthlyIncomeType.MILITARY_COMBAT_PAY,
	  'MilitaryFlight': LoanEmploymentMonthlyIncomeType.MILITARY_FLIGHT_PAY,
	  'MilitaryHazard': LoanEmploymentMonthlyIncomeType.MILITARY_HAZARD_PAY,
	  'MilitaryOverseas': LoanEmploymentMonthlyIncomeType.MILITARY_OVERSEAS_PAY,
	  'MilitaryProp': LoanEmploymentMonthlyIncomeType.MILITARY_PROP_PAY,
	  'MilitaryQuarters': LoanEmploymentMonthlyIncomeType.MILITARY_QUARTERS_ALLOWANCE,
	  'MilitaryRations': LoanEmploymentMonthlyIncomeType.MILITARY_RATIONS_ALLOWANCE,
	  'MilitaryVariableHousing': LoanEmploymentMonthlyIncomeType.MILITARY_VARIABLE_HOUSING_ALLOWANCE,
	  
	  // Generic fallbacks
	  'Other': LoanOtherIncomeType.OTHER_NON_EMPLOYMENT,
	  'other': LoanOtherIncomeType.OTHER_NON_EMPLOYMENT,
	  'OTHER': LoanOtherIncomeType.OTHER_NON_EMPLOYMENT
	}
	
	return typeMap[mismoType] || LoanOtherIncomeType.OTHER_NON_EMPLOYMENT
  }

  // MISMO to Mortdash marital status conversion (opposite of MortdashMaritalStatusToMismoMaritalStatus)
export const MismoMaritalStatusToMortdashMaritalStatus2 = (mismoMaritalStatus: MismoMaritalStatus | string): LoanApplicationMaritalStatus => {
	const typeMap: Record<string, LoanApplicationMaritalStatus> = {
	  'Married': LoanApplicationMaritalStatus.MARRIED,
	  'Unmarried': LoanApplicationMaritalStatus.NOT_MARRIED,
	  'NotMarried': LoanApplicationMaritalStatus.NOT_MARRIED,
	  'Separated': LoanApplicationMaritalStatus.SEPARATED,
	  'Single': LoanApplicationMaritalStatus.SINGLE,
	  'Divorced': LoanApplicationMaritalStatus.DIVORCED,
	  'Widowed': LoanApplicationMaritalStatus.WIDOWED
	}
	
	return typeMap[mismoMaritalStatus] || LoanApplicationMaritalStatus.NOT_MARRIED
  }

  // Reverse mapping for MISMO REO status to Mortdash REO status
export const MismoOwnedPropertyDispositionStatusTypeToMortdashREOStatus = (mismoStatus: MismoOwnedPropertyDispositionStatusType2 | string): string => {
	const typeMap: Record<string, string> = {
	  [MismoOwnedPropertyDispositionStatusType2.CURRENT]: 'current',
	  [MismoOwnedPropertyDispositionStatusType2.PENDING_SALE]: 'pending_sale',
	  [MismoOwnedPropertyDispositionStatusType2.SOLD]: 'sold',
	  [MismoOwnedPropertyDispositionStatusType2.RENTED]: 'rented',
	  [MismoOwnedPropertyDispositionStatusType2.UNDER_CONTRACT]: 'under_contract'
	}
	
	return typeMap[mismoStatus] || 'current'
  }

/** Maps portal declaration answers ('yes' / 'no' / boolean / empty) to MISMO "true" | "false" strings. */
export const MortdashDeclarationAnswerToMismoBoolean = (
	answer: string | boolean | null | undefined
): 'true' | 'false' => {
	if (answer === true) return 'true'
	if (answer === false) return 'false'
	const s = String(answer ?? '').trim().toLowerCase()
	if (s === 'yes' || s === 'true' || s === 'y' || s === '1') return 'true'
	return 'false'
}